module.exports = __webpack_public_path__ + "static/autokwix-logo.228ac847.svg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/autokwix-logo.svg
// module id = 726
// module chunks = 168707334958949